import { useAuthStore } from '@features/auth';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Box } from '@mui/material';

export const Route = createFileRoute('/_staff')({
  beforeLoad: async () => {
    const accessToken = useAuthStore.getState().accessToken;
    const isStaff = useAuthStore.getState().isStaff;

    if (!accessToken) {
      // Unauthenticated users go to the staff login page.
      throw redirect({ to: '/auth/staff' });
    }

    if (!isStaff) {
      // Authenticated users without staff role go to homepage.
      throw redirect({ to: '/' });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box
      sx={{
        height: '1000px',
        backgroundColor: '#FFFFFFFF',
      }}
    >
      <Outlet />
    </Box>
  );
}
